export default function contentWysiwyg() {
    $(document).ready(function() {
        $(".content-wysiwyg table").each(function() {
            if ($(this).parent().hasClass('table-responsive') == false) {
                $(this).wrap('<div class="table-responsive"></div>');
            }
            if ($(this).hasClass('table') == false) {
                $(this).addClass('table');
            }
        });

        let $releaseNotesCards = $('#release-notes-cards');
        let $releaseNotesTable = $('#release-notes-table');
        if ($releaseNotesCards.length && $releaseNotesTable.length) {
            let columnNames = [];
            $releaseNotesTable.find('th').each(function() {
                columnNames.push($(this).text());
            });
            $releaseNotesTable.find('tbody tr').each(function() {
                let $card = $($releaseNotesCards.data('card-prototype'));
                $(this).find('td').each(function(index) {
                    let th = columnNames[index];
                    let td = $(this).text();
                    let row = $releaseNotesCards.data('card-row-prototype');
                    row = row.replace('__TH__', th);
                    row = row.replace('__TD__', td);
                    let $row = $(row);
                    $card.append($row);
                });
                $releaseNotesCards.append($card);
            });
        }

        $('.content-wysiwyg img').addClass('img-fluid');
    });
}
